import { TFunction } from "i18next";
import * as yup from "yup";

export const contactFormSchema = (t: TFunction<"formErrors">) =>
  yup.object({
    email: yup.string().email(t("formErrors:string.email")).required(t("formErrors:required")),
    message: yup
      .string()
      .required(t("required"))
      .max(10000, t("formErrors:string.max", { count: 10000 }))
  });
